import Button from '@/common/components/base/button/Button';
import {
  MapEntranceModalType,
  MapEntranceModalWrapperType,
} from '@/common/components/base/input/mapInput/modals/mapEntrance/MapEntranceModal.type';
import MainModal from '@/common/components/base/modal/Modal';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import { Box } from 'styled-system/jsx';

export default ({
  open,
  closeModal,
  openMapModal,
  EntranceText,
}: MapEntranceModalWrapperType) => {
  return (
    <MainModal open={open} closeModal={closeModal}>
      <MapEntranceModal
        closeEntranceModal={closeModal}
        openMapModal={openMapModal}
        EntranceText={EntranceText}
      />
    </MainModal>
  );
};

const MapEntranceModal = ({
  closeEntranceModal,
  openMapModal,
  EntranceText,
}: MapEntranceModalType) => {
  const handleOpenMapModal = () => {
    closeEntranceModal();
    openMapModal();
  };
  return (
    <>
      <Box mt="10px" mb="20px">
        <TitleDescription my='15px' textStyle='b1'>{EntranceText}</TitleDescription>
        <Button color="primary" fullWidth onClick={handleOpenMapModal}>
          تایید و ادامه
        </Button>
      </Box>
    </>
  );
};
